import { Alert, Button } from '@mui/material'

const AvisoAlert = ({ aviso, closable = true, minWidth = '70%', handleClose = () => {} }) => {
  const isDismissible =
    aviso?.siempre_visible !== 'S' && aviso?.pedir_confirmacion !== 'S' && closable

  return (
    <Alert
      severity={aviso.color ?? 'error'}
      key={aviso.id}
      sx={{ minWidth: minWidth }}
      {...(isDismissible ? { onClose: () => handleClose(aviso.id, false) } : {})}
      action={
        aviso.pedir_confirmacion === 'S' ? (
          <Button color="inherit" size="small" onClick={() => handleClose(aviso.id)}>
            LEÍDO
          </Button>
        ) : null
      }
    >
      <div dangerouslySetInnerHTML={{ __html: aviso.texto_aviso }} />
    </Alert>
  )
}

export default AvisoAlert
